import groq from 'groq';

import { ASSET, PERSON } from '../common';
import { CAPTIONS_VIDEO } from '../common/captionsVideo';

export const TESTIMONIAL_GROUP = groq`
  title,
  testimonials[] {
    quote->{
      text,
      attribution -> {
        ${PERSON}
      }
    },
    video {
      ${CAPTIONS_VIDEO},
      poster { ${ASSET} }
    },
  }
`;

export const TESTIMONIAL_GROUP_BLOCK = groq`
  _type == 'timeline_testimonialGroup' => @-> {
    ${TESTIMONIAL_GROUP}
  }
`;
